import { AttachmentButtonEntity } from "./AttachmentButtonEntity";

export class AttachmentButtonClarificationEntity extends  AttachmentButtonEntity {
    
    /**
     * Constructor
     * 
     * @param id - The associated button unique id
     * @param key - The associated button key information 
     * @param text - The button text
     * @param clarification - Indicates whether or not the clarification is activated
     * @param clarificationOptions - The list of the dissatisfaction reasons to display
     * @param clarificationQuestion - The clarification question to display
     * @param watermark - The associated message watermark
     * @param finalMessage - The message to display to the user after button clicked
     */
    constructor(public id: string,
                public key: string,
                public text: string,
                public clarification: boolean,
                public clarificationOptions: AttachmentButtonEntity[],
                public clarificationQuestion: string,
                public watermark?: number,
                public finalMessage?: string) {
                    super(id,key,text);
                }
}
